// Copyright
// Copyright aptihealth, inc. 2019 All Rights Reserved
import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { connect } from "react-redux";

import "./App.scss";

import Alert from "../components/UI/Alert";
import ExceptionReport from "../components/Common/ExceptionReport";
import RouterFactory from "./RouterFactory/RouterFactory";
import Spinner from "../components/UI/Spinner";
import { Toaster } from "../component-library";
import { api } from "../APIRequests";
import { isConfigsLoaded } from "../redux/reducers/configsReducer";
import { loadConfigs } from "../redux/actions/configs";
import { loadFlags } from "../redux/actions/featureFlag";
import { loadToken } from "../redux/actions/auth";
import { privateFlagsLoaded, publicFlagsLoaded } from "../redux/reducers/featureFlagReducer";
import { removeToast } from "../redux/actions/toaster";

class App extends Component {
  constructor(props) {
    super(props);
    if (!window.location.pathname.startsWith("/auth") && window.location.pathname !== "/") {
      window.localStorage.setItem(
        "redirectAfterAuth",
        window.location.pathname + window.location.search,
      );
    }
    this.state = {
      configsLoaded: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps !== this.props &&
      isConfigsLoaded(this.props.configs) &&
      publicFlagsLoaded(this.props.flags) &&
      (!this.props.auth.accessToken ||
        (this.props.auth.accessToken && privateFlagsLoaded(this.props.flags)))
    ) {
      this.setState({ configsLoaded: true });
    }
  }

  async componentDidMount() {
    this.props.loadToken();
    this.emailTracking();
    this.props.loadConfigs();
    this.props.loadFlags();
  }

  emailTracking() {
    const params = new URLSearchParams(window.location.search.substring(1));
    let campaignId = params.get("campaign_id");
    let entityId = params.get("entity_id");
    let cohort = params.get("cohort");
    if (campaignId != null && entityId != null && cohort != null) {
      let data = {
        campaign_id: campaignId,
        entity_id: entityId,
        cohort: cohort,
        action: "CLICKED",
      };
      try {
        api.tracking.email({ data });
      } catch (error) {
        console.log(error);
      }
    }
  }

  render() {
    return (
      <Router>
        <div className="container-fluid tw:!px-0 tw:relative tw:min-h-screen tw:flex tw:flex-col tw:justify-start">
          {this.props.spinner.isLoading && <Spinner />}

          {this.props.alert && (
            <Alert
              buttonAction={this.props.alert.buttonAction}
              buttonText={this.props.alert.buttonText}
              customClass={this.props.alert?.customClass}
              customHTML={this.props.alert.customHTML}
              dismiss={this.props.alert.dismiss}
              message={this.props.alert.message}
              requestId={this.props.alert.requestId}
              show_exception_handling={this.props.alert.showExceptionReporting}
              type={this.props.alert.type}
            />
          )}

          {this.props.exceptionReport && (
            <ExceptionReport
              dismiss={this.props.exceptionReport.dismiss}
              requestId={this.props.exceptionReport.requestId}
            />
          )}

          <Toaster onDismissButtonClick={this.props.removeToast} toasts={this.props.toaster.toasts}>
            <></>
          </Toaster>

          {this.state.configsLoaded && <RouterFactory {...this.props} />}
        </div>
      </Router>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    alert: state.alert.alertConf,
    auth: state.auth,
    configs: state.configs,
    exceptionReport: state.exceptionReport.exceptionReportConf,
    flags: state.flags,
    spinner: state.loader,
    toaster: state.toaster,
  };
};

export default connect(mapStateToProps, { loadToken, loadConfigs, removeToast, loadFlags })(App);
